// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WeON","label":"styles_label__3aKJ7"};